module.exports = __webpack_public_path__ + "static/media/Checked.5a57cfbf.svg";